// Helpers

const interpolatePoints = (from, to, spacing, callback) => {
  if (!from || !to) return
  if (!spacing || spacing <= 0 ) return
  
  const dx = to.x - from.x
  const dy = to.y - from.y
  const distance = Math.hypot(dx, dy)
  const steps = Math.max(1, Math.floor(distance / spacing))

  for (let i = 0; i <= steps; i++) {
    const t = i / steps
    callback({
      x: from.x + dx * t,
      y: from.y + dy * t,
    })
  }
}

const makeBrushCanvas = ({ width, height, draw }) => {
  const dpr = window.devicePixelRatio || 1
  const canvas = document.createElement("canvas")
  const ctx = canvas.getContext("2d")

  canvas.width = width * dpr
  canvas.height = height * dpr

  ctx.scale(dpr, dpr)

  draw(ctx)

  return canvas
}

const createSoftBrush = (size, color, KonvaUtil) => {
  const radius = size / 2
  const rgb = KonvaUtil.getRGB(color)

  return makeBrushCanvas({
    width: radius * 2,
    height: radius * 2,
    draw: (ctx) => {
      const gradient = ctx.createRadialGradient(
        radius,
        radius,
        0,
        radius,
        radius,
        radius
      )

      gradient.addColorStop(0, `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 1)`)
      gradient.addColorStop(0.3, `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.35)`)
      gradient.addColorStop(1, `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0)`)

      ctx.fillStyle = gradient
      ctx.fillRect(0, 0, radius * 2, radius * 2)
    },
  })
}

const createVariableBrush = (size, color) => {
  return makeBrushCanvas({
    width: size * 2,
    height: size,
    draw: (ctx) => {
      ctx.translate(size, size / 2)
      ctx.rotate((-30 * Math.PI) / 180)

      ctx.fillStyle = color
      ctx.beginPath()
      ctx.ellipse(0, 0, size * 0.7, size * 0.18, 0, 0, Math.PI * 2)
      ctx.fill()
    },
  })
}

// Brushes

export const getBrushes = () => {
  const Konva = require('konva')
  const { Line, Util } = Konva

  return {
    hard: {
        id: 'hard',
        name: 'Hard round',
        mode: 'line',

        startStroke({ group, color, size, point }) {
          const line = new Line({
              points: [point.x, point.y],
              stroke: color,
              strokeWidth: size,
              lineCap: 'round',
              lineJoin: 'round',
              tension: 0.5,
              listening: false,
          })

          group.add(line)
          return line
        },
    },

    soft: {
        id: "soft",
        name: "Soft round",
        mode: "stamp",
        spacingRatio: 0.15,

        startStroke({ size, color }) {
            this.texture = createSoftBrush(size, color, Util)
        },

        drawStroke({ ctx, size, from, to }) {
            const spacing = size * this.spacingRatio

            interpolatePoints(from, to, spacing, (point) => {
                ctx.drawImage(
                    this.texture,
                    point.x - this.texture.width / 2,
                    point.y - this.texture.height / 2
                )
            })
        },
    },

    variable: {
        id: 'variable',
        name: 'Variable',
        mode: 'stamp',
        spacingRatio: 0.15,

        startStroke({ size, color }) {
            this.texture = createVariableBrush(size, color)
        },

        drawStroke({ ctx, size, from, to }) {
            const spacing = size * this.spacingRatio

            interpolatePoints(from, to, spacing, (point) => {
                ctx.drawImage(
                    this.texture,
                    point.x - this.texture.width / 2,
                    point.y - this.texture.height / 2
                )
            })
        },
    },
  }
}